export const buttonsGroup = {
    body: {
        textAlign: "center",
    },
};
